import { useEffect } from 'react';

import { useOnceReveal } from '@common/hooks';

import { useMaximumBenefitLog } from './useMaximumBenefitLog';

interface Props {
  product_id: string;
  policy_id: string;
  issuable: boolean;
}

export const useSendCouponDownload = ({ product_id, policy_id, issuable }: Props) => {
  const { targetRef, isRevealed } = useOnceReveal();
  const { impressionCouponDownloadUBL, clickCouponDownloadUBL } = useMaximumBenefitLog();

  useEffect(() => {
    if (isRevealed) {
      impressionCouponDownloadUBL(product_id, policy_id, issuable);
    }
  }, [isRevealed]);

  const onClickCouponDownloadUBL = () => {
    clickCouponDownloadUBL(product_id, policy_id);
  };

  return {
    targetRef,
    onClickCouponDownloadUBL,
  };
};
